// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const formatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'maxItemQty',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;
      let color;

      if (
        item &&
        item.maxItemQty &&
        item.maxItemQty.ActionPerOrderType &&
        item.maxItemQty.ActionPerOrderType !== 'none'
      ) {
        switch (item.maxItemQty.ActionPerOrderType) {
          case 'update':
            color = 'orange';
            break;
          case 'remove':
            color = 'red';
            break;
          case 'outofstock':
            color = 'gray';
            break;
          default:
            break;
        }
      }

      if (!color) return;

      wjcCore.addClass(elem.cell, color);
    },
  });

export default formatter;
